import { createSlice } from "@reduxjs/toolkit";

interface IPaymentButtonState {
  loading: boolean;
}

const initialState: IPaymentButtonState = {
  loading: false,
};

const paymentButtonSlice = createSlice({
  name: "paymentButton",
  initialState,
  reducers: {
    setPaymentButtonLoading(state, action) {
      state.loading = action.payload;
    },
    startPaymentButtonLoading(state) {
      state.loading = true;
    },
    stopPaymentButtonLoading(state) {
      state.loading = false;
    },
  },
});

export const {
  setPaymentButtonLoading,
  startPaymentButtonLoading,
  stopPaymentButtonLoading,
} = paymentButtonSlice.actions;

export default paymentButtonSlice.reducer;